import { createContext } from 'react';

import { AuthContextValue } from './auth.type';

/**
 * The context object only. The provider lives in `auth-provider.tsx`.
 *
 * Split so the hooks layer stops inheriting the provider's render tree:
 * `use-refresh-token-handler` needs nothing but this object and sits under
 * `use-generic-query`, which most of the app imports (B2B-2142). A convenience
 * `export { AuthContext } from './auth-context'` in the provider would restore that
 * edge — the figures are in the PR and the ticket, the invariant is here.
 */
export const AuthContext = createContext<AuthContextValue>({
  isAuthenticated: false,
  isImpersonated: false,
  signOut: () => {},
  recoverSessionOrSignOut: () => {},
  changeUser: () => {},
  resetAdminUser: () => {},
});
